import { Injectable, signal, WritableSignal, computed } from '@angular/core';
import { User } from '../models/user';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ChatStateService {
  sender: WritableSignal<User | null> = signal(null);
  recipient: WritableSignal<User | null> = signal(null);
  token: WritableSignal<string | null> = signal(null);
  isOptedOut: WritableSignal<boolean> = signal(false);
  maxMessageLength: WritableSignal<number> = signal(environment.MAX_MESSAGE_LENGTH);
  maxMessageLengthError: WritableSignal<string> = signal(environment.MAX_MESSAGE_LENGTH_ERROR);
  chatReady = computed(() =>
    !!this.sender() && !!this.recipient() && !!this.token()
  );
  hasUnreadMessages: WritableSignal<boolean> = signal(false);
}
